import {SwapFlowState, SwapFlowView} from "./SwapFlowContext.types";

const initialSwapFlowState: SwapFlowState = {
  view: SwapFlowView.Form
};

export {initialSwapFlowState};
